export class FactStatement {
    id: string = '';
    quote_id: string = '';
    question_id: string = '';
    response: number = null;
    response_bool: boolean = false;
    response_text: string = '';
    display_order: number = 0;
}
